import React from 'react';
import { formatarTelefone } from '../../../../utils/telefoneHelper';
import Par from '../../../comum/containers/par';
import Subtitle from '../../../../components/Subtitle/subtitle.component';


export default ({ transacao }) => (
	<div className='col-md-12 pl-0 pr-0'>
		{transacao.nome !== null && (
			<React.Fragment>
				<div className='d-flex'>
					<Par label='Item' value={transacao.daca.nome} />
					<Par label='Tipo de transação' value='Entrada' />
				</div> {/* d-flex */}

				<div className='d-flex'>
					<Par label='Tipo de entrada' value={transacao.destinoEstoque.tipoEstoque} />
					<Par label='Número da ARP' value={transacao.destinoEstoque.numero} />
				</div> {/* d-flex */}

				<div className='d-flex'>
					<Par label='Quantidade' value={transacao.quantidadeEntradaSaida} />
					<Par label='Valor unitário' value={`R$ ${transacao.destinoEstoque.valorUnitarioFormatado}`} />
				</div> {/* d-flex */}

				<div className='d-flex'>
					<Par label='Validade' value={transacao.destinoEstoque.validade.split(' ') ? transacao.destinoEstoque.validade.split(' ')[0] : transacao.destinoEstoque.validade} />
					<Par label='Data de entrada' value={transacao.dataCadastro} />
				</div>

				<Par
					className='col-12'
					label='CREPDEC(s) atendida(s)'
					value={transacao.destinoEstoque.crepdecs.reduce((acm, current, index, credpecs) => {
						let char = '';
						if (index < credpecs.length - 2) {
							char = ',';
						} else if (index < credpecs.length - 1) {
							char = ' e';
						}
						return `${acm} ${current.nomeFormatado}${char}`;
					}, '')}
				/>
				<div className='col-12 mb-2'>
					<Subtitle>Dados da Empresa</Subtitle>
				</div>
				<Par className='col-12' label='Empresa' value={transacao.destinoEstoque.empresa.nome} />

				<div className='d-flex'>
					<Par label='CNPJ' value={transacao.destinoEstoque.empresa.cnpj} />
					<Par label='E-mail' value={transacao.destinoEstoque.empresa.email} />
				</div>

				<div className='d-flex'>
					<Par label='Telefone principal' value={formatarTelefone(transacao.destinoEstoque.empresa.telefonePrincipal)} />
					<Par label='Telefone secundário' value={formatarTelefone(transacao.destinoEstoque.empresa.telefoneSecundario)} />
				</div>

				<div className='d-flex'>
					<Par label='CEP' value={transacao.destinoEstoque.empresa.endereco.cep} />
					<Par label='Município' value={transacao.destinoEstoque.empresa.endereco.municipio.nome} />
				</div>

				<div className='d-flex'>
					<Par label='Logradouro' value={transacao.destinoEstoque.empresa.endereco.logradouro} />
					<Par label='Bairro' value={transacao.destinoEstoque.empresa.endereco.bairro} />
				</div>

				<div className='d-flex'>
					<Par label='Número' value={transacao.destinoEstoque.empresa.endereco.numero} />
					<Par label='Complemento' value={transacao.destinoEstoque.empresa.endereco.complemento ? transacao.destinoEstoque.empresa.endereco.complemento : '--'} />
				</div>


			</React.Fragment>
		)}
	</div>
);
